// import  AppNavigator from "../../Navigation/navigation";
import { persistCombineReducers } from "redux-persist";
import storage from "redux-persist/lib/storage";

const initialState = {
  mobile: "",
  isAddedToHome: false,
  isFaNum: true,
  activeTabBar: 1,
  isLogin: false,
  token: null,
  isActive: true,
  isOpenDrawer: false,
  userInfo: null,
  subscribeData: null,
  reload: true
};

function auth(state = initialState, action) {
  switch (action.type) {

    case "IS_LOGIN":
      console.log('isLogin',action.isLogin,action.token);
      return {
        ...state,
        isLogin: action.isLogin,
        token: action.token
      };

    case "INIT":
      return {
        ...state,
        userInfo: action.payload,
        subscribeData: action.subscribeData
      }



    default:
      return state;
  }
}



function params(state = initialState, action) {
  switch (action.type) {
    case 'IS_ACTIVE':
      return {
        ...state,
        isActive: action.isActive
      }

    default:
      return state;
  }
}

function persistedParams(state = { ...initialState, bills: [] }, action) {
  switch (action.type) {
    case "IS_ADD_TO_HOME":
      return {
        ...state,
        isAddedToHome: action.payload,
      };
    case "IS_FA_NUM":
      return {
        ...state,
        isFaNum: action.payload
      };
    case "ACTIVE_TAB_BAR":
      return {
        ...state,
        activeTabBar: action.payload
      };
    case "IS_OPEN_DRAWER":
      return {
        ...state,
        isOpenDrawer: action.payload
      };
    case "RELOAD":
      return {
        ...state,
        reload: action.reload,
      }

    default:
      return state;
  }
}

const persistConfig = {
  key: "root",
  storage: storage,
  whitelist: ["persistedParams", "auth"],
};
const AppReducer = persistCombineReducers(persistConfig, {
  auth,
  params,
  persistedParams,
});

export default AppReducer;